import { Avatar } from '@mui/material';
import { AnimationLight, AnimationSummary } from '@wwf/sdk';
import { useResource } from '@app/misc/useResource';
import { useRecordContext } from 'react-admin';

export const AnimationCover = () => {
    const record = useRecordContext<AnimationSummary | AnimationLight>();
    const { data: src } = useResource(record?.image?.id);

    return (
        <Avatar
            variant="rounded"
            src={src ?? undefined}
            alt={record?.name ?? 'Animation'}
            sx={{ width: 40, height: 40 }}
        >
            {(record?.name ?? '').charAt(0)}
        </Avatar>
    );
};
